import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import './AddDistrict.css';

const AddDistrictAdmin = () => {
  const { districtId } = useParams();
  const [district, setDistrict] = useState(null);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    first_name: '',
    last_name: '',
    title: '',
    password: '',
    role: 'district_admin'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchDistrict();
  }, [districtId]);

  const fetchDistrict = async () => {
    try {
      const response = await axios.get(`/api/districts/${districtId}`);
      setDistrict(response.data);
    } catch (error) {
      console.error('Failed to fetch district:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await axios.post('/api/users/district-user', {
        ...formData,
        district_id: districtId
      });
      navigate(`/superadmin/districts/${districtId}/admins`);
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to create district admin');
    } finally {
      setLoading(false);
    }
  };

  if (!district) {
    return <div>Loading...</div>;
  }

  return (
    <div className="add-district">
      <h2>Add District User</h2>
      <p><strong>District:</strong> {district.district_name} (non-editable)</p>
      {error && <div className="error-message">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>Username *</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Password *</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength={8}
            />
            <small>A password reset link will be sent to the email address</small>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>User Permission Level *</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="district_admin">District Admin - Full access to all district functions, can manage users and settings</option>
              <option value="district_editor">District Editor - Can view/edit student data and forms, cannot manage users or registration codes</option>
              <option value="district_user">District User - Read-only access to district and student data, can create/run reports</option>
            </select>
            <small>
              {formData.role === 'district_admin' && 'Full administrative access including user management, registration codes, and school settings.'}
              {formData.role === 'district_editor' && 'Can view and edit student data and forms. Cannot add/edit users, registration codes, or school information. Suitable for administrative assistants and secretaries.'}
              {formData.role === 'district_user' && 'Read-only access to all district and student data. Can create and run reports but cannot modify any data. Suitable for staff needing information access.'}
            </small>
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Creating...' : 'Create District User'}
          </button>
          <button 
            type="button" 
            className="btn-secondary" 
            onClick={() => navigate(`/superadmin/districts/${districtId}/admins`)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddDistrictAdmin;

